// material-ui
import { useTheme } from '@mui/material/styles';

// asset del logo
import logoSanLorenzo from '../../assets/images/san-lorenzo.svg';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <img src={logoSanLorenzo} alt="San Lorenzo Vini Icon" width="35" height="35" style={{ objectFit: 'contain' }} />
  );
}
